import React, { useEffect, useState, useMemo, useRef } from "react"

import { Grid, Box, Button, Link, Modal, MenuItem, Select, FormControl, InputLabel } from "@mui/material"
import { CheckCircle, XCircle, Flame, Clock } from 'lucide-react';

import { apiGetMediaElement } from "../../../../services/Admin/media";
import { showServicesApi } from "../../../../services/Admin/service";
import { showUsersByRoleApi } from "../../../../services/Admin/user"
import { searchEstimates, addEstimates, updateEstimateStatus } from "../../../../services/Admin/estimates"

import TableC from "../../../../components/Admin/TableC"
import LoadingProgress from "../../../../components/LoadingProgress"
import timestampToDate from "../../../../components/timestampToDate"
import { getMimeTypeByFormat } from "../../../../components/Admin/Media/mediaUtils";
import Card from "../../../../components/Admin/Card";
import Typography from "@mui/material/Typography"

import InvoiceModal from "./InvoiceModal";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 20,
    p: 4,
    minWidth: 750,
    maxWidth: 750,
    borderRadius: 3,
    position: "relative"
};

export default function Management() {
    const [transactions, setTransactions] = useState(null)
    // Estado para el filtro de estado
    const [statusFilter, setStatusFilter] = useState('');
    // Estado para el filtro global de texto
    const [globalFilter, setGlobalFilter] = useState("");
    // Estado para el tipo de IVA
    const [tipoIva, setIvaType] = useState("")
    const [loading, setLoading] = useState(true)
    const [open, setOpen] = useState(false)
    const [openExport, setOpenExport] = useState(false)
    const [msgSuccess, setMsgSuccess] = useState(false)
    const [msgSuccessExport, setMsgSuccessExport] = useState(false)
    const [msgDanger, setMsgDanger] = useState(null)
    const [msgDangerModal, setMsgDangerModal] = useState(null)
    const [spiner, setSpiner] = useState(false)
    const [spinerModal, setSpinerModal] = useState(false)
    const [invoiceID, setInvoinceID] = useState("")
    const [dateBill, setDateBill] = useState()
    const [dateOriginalBill, setDateOriginalBill] = useState()
    const [motivo, setMotivo] = useState("")
    const [concepto, setConcepto] = useState("")
    const [price, setPrice] = useState("")
    const [iva, setIva] = useState("")
    const [invoiceTypeSpecial, setInvoiceTypeSpecial] = useState(false)
    const [subtotal, setSubtotal] = useState("")
    const [invoicePdf, setInvoicePdf] = useState(null)
    const [invoiceShowPrice, setInvoiceShowPrice] = useState(true)

    const [listUserClient, setListUserClient] = useState([])
    const [defaultUserClientValueList, setDefaultUserClientValueList] = useState({})
    const [idClient, setIdClient] = useState(null)
    const [isClientSelect, setIsClientSelect] = useState(false)
    const timeoutRef = useRef(null)

    const [dateExportStart, setDateExportStart] = useState()
    const [dateExportEnd, setDateExportEnd] = useState()
    const [msgDangerModalExport, setMsgDangerModalExport] = useState(null)
    const [spinerModalExport, setSpinerModalExport] = useState(false)

    const [servicios, setServicios] = useState([])
    const [servicioSeleccionado, setServicioSeleccionado] = useState(null)
    const [serviciosAñadidos, setServiciosAñadidos] = useState([])


    // Estado para el modal de cambio de estado
    const [statusModalOpen, setStatusModalOpen] = useState(false);
    const [statusModalId, setStatusModalId] = useState(null);
    const [statusModalCurrent, setStatusModalCurrent] = useState('PENDING');
    const [statusModalNew, setStatusModalNew] = useState('PENDING');
    const statusOrder = ['PENDING', 'HOT', 'WON', 'LOST'];

    // Modal para cambiar el estado
    const handleStatusModalClose = () => {
        setStatusModalOpen(false);
        setStatusModalId(null);
        setStatusModalCurrent('PENDING');
        setStatusModalNew('PENDING');
    };

    const handleStatusModalSave = async () => {
        if (!statusModalId || statusModalNew === statusModalCurrent) {
            handleStatusModalClose();
            return;
        }
        try {
            await updateEstimateStatus({ id: statusModalId, status: statusModalNew });
            setTransactions((prev) => prev.map((item) =>
                item.id === statusModalId ? { ...item, status: statusModalNew } : item
            ));
            handleStatusModalClose();
        } catch (err) {
            setMsgDanger(["No se pudo actualizar el estado"]);
            handleStatusModalClose();
        }
    };

    const handleOpen = () => {
        setMsgSuccess(false)
        setMsgSuccessExport(false)
        setMsgDanger(null)
        setMsgDangerModal(null)
        setSpiner(false)
        setSpinerModal(false)
        setDateBill("")
        setDateOriginalBill(null)
        setInvoinceID(null)
        setMotivo("")
        setConcepto("")
        setPrice("")
        setIva("")
        setInvoiceTypeSpecial(false)
        setDefaultUserClientValueList(null)
        setIdClient(null)
        setIsClientSelect(false)
        setInvoicePdf(null)
        setOpen(true
        )
    }

    const handleClose = () => setOpen(false)

    const handleOpenExport = () => {
        setMsgSuccess(false)
        setMsgSuccessExport(false)
        setMsgDanger(null)
        setMsgDangerModal(null)
        setMsgSuccessExport(false)
        setMsgDangerModalExport(null)
        setSpinerModalExport(false)
        setDateExportStart("")
        setDateExportEnd("")
        setOpenExport(true)
    }
    const handleCloseExport = () => setOpenExport(false)

    // Filtrado por estado y texto global
    const filteredTransactions = useMemo(() => {
        let filtered = transactions || [];
        if (statusFilter) {
            filtered = filtered.filter(t => t.status === statusFilter);
        }
        if (globalFilter) {
            const search = globalFilter.toLowerCase();
            filtered = filtered.filter(row =>
                Object.values(row).some(
                    val =>
                        typeof val === 'string' && val.toLowerCase().includes(search)
                )
            );
        }
        return filtered;
    }, [transactions, statusFilter, globalFilter]);

    const columns = useMemo(
        () => [
            {
                Header: "FECHA DE EMISIÓN",
                accessor: "date",
            },
            {
                Header: "NUMERO PRESUPUESTO",
                accessor: "estimatesNumber",
            },
            {
                Header: "CIF",
                accessor: "dni",
            },
            {
                Header: "CLIENTE",
                accessor: "client",
            },
            {
                Header: "PRECIO (SIN IVA)",
                accessor: "totalPrice",
            },
            {
                Header: "TOTAL (CON IVA)",
                accessor: "totalPriceIva",
            },
            {
                Header: "ESTADO",
                accessor: "status",
                Cell: ({ value, row }) => {
                    // Map status to Spanish, color, and icon
                    const statusMap = {
                        WON: {
                            text: 'Ganado',
                            color: '#4caf50',
                            Icon: CheckCircle
                        },
                        LOST: {
                            text: 'Perdido',
                            color: '#f44336',
                            Icon: XCircle
                        },
                        HOT: {
                            text: 'Probabilidad Alta',
                            color: '#ff9800',
                            Icon: Flame
                        },
                        PENDING: {
                            text: 'Pendiente',
                            color: '#bdbdbd', // light gray
                            Icon: Clock
                        },
                    };
                    const status = statusMap[value] || { text: value, color: '#757575', Icon: null };
                    const Icon = status.Icon;

                    // Click handler to open modal
                    const handleStatusClick = (e) => {
                        e.stopPropagation();
                        if (row && row.original && row.original.id) {
                            setStatusModalId(row.original.id);
                            setStatusModalCurrent(value);
                            setStatusModalNew(value);
                            setStatusModalOpen(true);
                        }
                    };

                    return (
                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '6px',
                                padding: '2px 12px',
                                borderRadius: '12px',
                                background: status.color + '22',
                                color: status.color,
                                fontWeight: 600,
                                fontSize: '0.95em',
                                letterSpacing: '0.5px',
                                border: `1px solid ${status.color}`,
                                cursor: 'pointer',
                                userSelect: 'none',
                                transition: 'box-shadow 0.2s',
                            }}
                            title="Cambiar estado"
                            onClick={handleStatusClick}
                        >
                            {Icon && <Icon size={18} style={{ color: status.color, marginTop: "-8.5px" }} />}
                            {status.text}
                        </span>
                    );
                    // Modal para cambiar el estado
                    function handleStatusModalClose() {
                        setStatusModalOpen(false);
                        setStatusModalId(null);
                        setStatusModalCurrent('PENDING');
                        setStatusModalNew('PENDING');
                    }

                    async function handleStatusModalSave() {
                        if (!statusModalId || statusModalNew === statusModalCurrent) {
                            handleStatusModalClose();
                            return;
                        }
                        try {
                            await updateEstimateStatus({ id: statusModalId, status: statusModalNew });
                            setTransactions((prev) => prev.map((item) =>
                                item.id === statusModalId ? { ...item, status: statusModalNew } : item
                            ));
                            handleStatusModalClose();
                        } catch (err) {
                            setMsgDanger(["No se pudo actualizar el estado"]);
                            handleStatusModalClose();
                        }
                    }
                },
            },
            {
                Header: "ACCIONES",
                accessor: "actions",
            }
        ],
        []
    )

    const getFacturas = async () => {
        setLoading(true)
        searchEstimates().then(resp => {
            let temp = null
            temp = resp.data.data.map((doc) => {
                return {
                    ...doc,
                    date: timestampToDate(doc.date, false),
                    client: `${doc.user.name} ${doc.user.surnames}`,
                    dni: doc.user.dni,
                    cc: doc.user.cc,
                    status: doc.status,
                    actions: (
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                                disabled={!doc.file}
                                onClick={() => handleDownload(doc.file, `${doc.estimatesNumber}.pdf`)}
                                target="_blank"
                                sx={{
                                    borderRadius: 2,
                                    paddingLeft: 2,
                                    paddingRight: 2,
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    boxShadow: 'none'
                                }}
                            >
                                Descargar
                            </Button>
                        </div>
                    )
                }
            })
            setTransactions(temp)
            setLoading(false)
        }).catch(error => {
            console.error(error)
        })
    }

    const createInvoice = async () => {
        setMsgDanger(null)
        setMsgDangerModal(null)
        setInvoicePdf(null)
        setMsgSuccess(false)
        setMsgSuccessExport(false)
        setSpiner(true)

        if (!dateBill) {
            setMsgDangerModal(["Debe seleccionar una fecha de emisión para la factura."])
            setSpiner(false)
            return
        }

        if (invoiceTypeSpecial && !invoiceID) {
            setMsgDangerModal(["Debe introducir el ID de la factura a abonar."])
            setSpiner(false)
            return
        }

        if (idClient === null || idClient === undefined) {
            setMsgDangerModal(["Debe seleccionar un cliente para la factura."])
            setSpiner(false)
            return
        }

        if (!price) {
            setMsgDangerModal(["Debe introducir el importe TOTAL para la factura"])
            setSpiner(false)
            return
        }

        if (!iva) {
            setMsgDangerModal(["Debe introducir el IVA para la factura"])
            setSpiner(false)
            return
        }

        addEstimates({
            dateBill: dateBill,
            idClient: idClient,
            invoiceTypeSpecial: invoiceTypeSpecial,
            invoiceID: invoiceID,
            motivo: motivo,
            concepto: concepto,
            price: price,
            subtotal: subtotal,
            iva: iva,
            ivaType: tipoIva,
            servicios: serviciosAñadidos,
            invoiceShowPrice: invoiceShowPrice ? 1 : 0
        }).then(resp => {
            if (resp.data.status) {
                handleDownload(resp.data?.data.file, `${resp.data?.data?.estimatesNumber}.pdf`)
                setInvoicePdf(resp.data?.data)
                setMsgSuccess(true)
            } else {
                setMsgDanger(resp.data?.errors)
            }
            setOpen(false)
            setSpiner(false)
        }).catch(err => {
            setMsgDanger(err?.response?.data?.errors)
            setOpen(false)
            setSpiner(false)
        })
    }

    const handleDownload = (file, filename) => {
        if (file) {
            // Si inicialmente inicia con https
            if (file.startsWith("https")) {
                window.open(file, "_blank")
                return
            }
            apiGetMediaElement(file).then(resp => {
                const base64Content = resp.data?.content;
                const format = 'pdf';
                if (base64Content) {
                    const filenameIn = filename || `archivo.${format || "pdf"}`;
                    const mimeType = getMimeTypeByFormat(format);
                    const link = document.createElement("a");
                    link.href = `data:${mimeType};base64,${base64Content}`;
                    link.download = filenameIn;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            })
        }
    };

    const getServicesType = async () =>{
        showServicesApi().then(resp => {
            // Filtrar solo los servicios activos
            const temp = resp.data.data
                .filter(doc => doc.isActive)
                .map(doc => ({ ...doc }));
            setServicios(temp)
        }).catch(err => {
            console.error(err)
        })
    }

    const handleChageDate = (event, value) => {
        setDateBill(event.target.value)
    }

    const changeClient = (event, value) => {
        if (value !== null) {
            setIdClient(value.id)
            setDefaultUserClientValueList({
                id: value.id,
                name: value.name,
                surnames: value.surnames,
                email: value.email
            })
            setIsClientSelect(true)
        } else {
            removeClient()
        }
    }

    const handleChangePrice = (value) => {
        // Normalize entrada
        const normalized = String(value).replace(",", ".");
        const total = parseFloat(normalized) || 0;

        const ivaRate = tipoIva / 100;

        // Càlcul en cèntims: més precís
        const totalCents = Math.round(total * 100);
        const subtotalCents = Math.round(totalCents / (1 + ivaRate));
        const ivaCents = totalCents - subtotalCents;

        // Actualitzem estat amb format europeu
        setPrice(value); 
        setSubtotal((subtotalCents / 100));
        setIva((ivaCents / 100));
    }

    const removeClient = () => {
        setDefaultUserClientValueList(null)
        setIsClientSelect(false)
        setIdClient(null)
    }

    // Lista con todos los clientes de la plataforma
    const getClients = async () => {
        showUsersByRoleApi({ roleName: "ROLE_CLIENT" }).then(resp => {
            if (resp.data.status) {
                const temp = resp.data.data.map((doc) => {
                    return {
                        id: doc.id,
                        ...doc,
                    }
                })
                setListUserClient(temp)
            }
        })
    }

    useEffect(() => {
        if (serviciosAñadidos.length > 0) {
            const tipoIvaActual = String(serviciosAñadidos[0].iva);
            setIvaType(tipoIvaActual);
        } else {
            setIvaType("");
        }
    }, [serviciosAñadidos]);

    useEffect(() => {
        getFacturas()
        getClients()
        getServicesType()
    }, [open]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
        <Card>
            <div className="cointainer cointainer-bt">
                <h1>Presupuestos</h1>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                        onClick={handleOpen}
                        color="primary"
                        variant="outlined"
                        style={{ width: 200, marginLeft: "10px", }}
                    >
                        Crear
                    </Button>
                </div>
            </div>

            {msgSuccess && (
                <Box className="alert-success">
                    La factura se ha generado correctamente: <Link href={invoicePdf} target="_blank"
                        color="inherit">Mostrar</Link>
                </Box>
            )}

            {msgSuccessExport && (
                <Box className="alert-success">
                    La exportación se ha generado correctamente
                </Box>
            )}

            {msgDanger && (
                <Box className="alert-danger">
                    {msgDanger.map((item, index) => {
                        return (<span key={index}>{item} <br /></span>)
                    })}
                </Box>
            )}

            <LoadingProgress loading={loading} />
            {!loading && (
                <>
                    <TableC
                        columns={columns}
                        data={filteredTransactions}
                        globalFilter={globalFilter}
                        setGlobalFilter={setGlobalFilter}
                    >
                        <FormControl size="small" variant="outlined" style={{ minWidth: 180 }}>
                            <InputLabel id="status-filter-label">Filtrar por estado</InputLabel>
                            <Select
                                labelId="status-filter-label"
                                value={statusFilter}
                                onChange={e => setStatusFilter(e.target.value)}
                                label="Filtrar por estado"
                            >
                                <MenuItem value="">Todos</MenuItem>
                                <MenuItem value="PENDING">Pendiente</MenuItem>
                                <MenuItem value="HOT">Probabilidad Alta</MenuItem>
                                <MenuItem value="WON">Ganado</MenuItem>
                                <MenuItem value="LOST">Perdido</MenuItem>
                            </Select>
                        </FormControl>
                    </TableC>
                </>
            )}

            <InvoiceModal
                open={open}
                handleClose={handleClose}
                spiner={spiner}
                msgDangerModal={msgDangerModal}
                invoiceTypeSpecial={invoiceTypeSpecial}
                setInvoiceTypeSpecial={setInvoiceTypeSpecial}
                invoiceID={invoiceID}
                dateOriginalBill={dateOriginalBill}
                dateBill={dateBill}
                listUserClient={listUserClient}
                defaultUserClientValueList={defaultUserClientValueList}
                servicioSeleccionado={servicioSeleccionado}
                setServicioSeleccionado={setServicioSeleccionado}
                servicios={servicios}
                serviciosAñadidos={serviciosAñadidos}
                setServiciosAñadidos={setServiciosAñadidos}
                tipoIva={tipoIva}
                setIvaType={setIvaType}
                iva={iva}
                setIva={setIva}
                price={price}
                motivo={motivo}
                setMotivo={setMotivo}
                concepto={concepto}
                setConcepto={setConcepto}
                createInvoice={createInvoice}
                spinerModal={spinerModal}
                setInvoinceID={setInvoinceID}
                setDateOriginalBill={setInvoinceID}
                setDateBill={setInvoinceID}
                setDefaultUserClientValueList={setInvoinceID}
                setIsClientSelect={setInvoinceID}
                setIdClient={setInvoinceID}
                setPrice={setPrice}
                invoiceShowPrice={invoiceShowPrice}
                setInvoiceShowPrice={setInvoiceShowPrice}
                handleChageDate={handleChageDate}
                changeClient={changeClient}
                handleChangePrice={handleChangePrice}
                removeClient={removeClient}
                subtotal={subtotal}
            />
        </Card>
        {/* Modal para cambiar estado */}
        <Modal
            open={statusModalOpen}
            onClose={handleStatusModalClose}
            aria-labelledby="modal-status-title"
            aria-describedby="modal-status-desc"
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                minWidth: 320,
                outline: 'none',
            }}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                   Cambiar estado
                </Typography>
                <FormControl fullWidth sx={{ mt: 2, mb: 2 }}>
                    <InputLabel id="select-status-label">Estado</InputLabel>
                    <Select
                        labelId="select-status-label"
                        value={statusModalNew}
                        label="Estado"
                        onChange={e => setStatusModalNew(e.target.value)}
                        size="small"
                    >
                        <MenuItem value="PENDING">Pendiente</MenuItem>
                        <MenuItem value="HOT">Probabilidad Alta</MenuItem>
                        <MenuItem value="WON">Ganado</MenuItem>
                        <MenuItem value="LOST">Perdido</MenuItem>
                    </Select>
                </FormControl>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16 }}>
                        <div style={{ width: "50%" }}>
                            <Button
                                onClick={handleStatusModalClose}
                                variant="contained"
                                className="MuiButton-containedCancel"
                                fullWidth
                            >
                                Cancelar
                            </Button>
                        </div>
                        <div style={{ width: "50%" }}>
                            <Button
                                onClick={handleStatusModalSave}
                                color="primary"
                                variant="contained"
                                fullWidth
                            >
                                Guardar
                            </Button>
                        </div>
                    </div>
                </Box>
            </Box>
        </Modal>
        </>
    )
}
